module.exports = "<footer>\n  <p>Version 1.2.0 2018 &#169; BEX - Admin Dashboard</p>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/common/footer/footer.component.html
// module id = ../../../../../src/app/components/common/footer/footer.component.html
// module chunks = main